import { Reveal } from "./Reveal";
import { TRUST } from "@/data/content";

export const TrustBar = () => (
  <section className="bg-brand-ink text-white" aria-label="Kärnvärden">
    <div className="mx-auto max-w-6xl px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {TRUST.map((item, i) => (
          <Reveal
            key={item.title}
            delay={i * 0.05}
            className="bg-brand-ink py-9 pr-6 sm:px-7 sm:py-12 lg:py-16"
          >
            <div className="font-display text-xl leading-snug text-white lg:text-2xl">{item.title}</div>
            <p className="mt-3 text-[15px] leading-relaxed text-white/65 md:text-base">{item.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
